import { Routes } from '@angular/router';
import { addMultipleItemsRoutes } from './add-multiple-items/add-multiple-items.routes';
import { cardListRoutes } from './card-list/card-list.routes';
import { getBindersRoutes } from './get-binders/get-binders.routes';
import { openBindersRoutes } from './open-binders/open-binders.routes';
import { openSpinnersRoutes } from './open-spinners/open-spinners.routes';
import { requestPhysicalCollectionRoutes } from './request-physical-collection/request-physical-collection.routes';

export const userCollectionItemsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./user-collection-items.page').then(
        (m) => m.UserCollectionItemsPage
      ),
  },
  {
    path: 'add-multiple-items',
    children: addMultipleItemsRoutes,
  },
  {
    path: 'card-list',
    children: cardListRoutes,
  },
  {
    path: 'get-binders',
    children: getBindersRoutes,
  },
  {
    path: 'open-binders',
    children: openBindersRoutes,
  },
  {
    path: 'open-spinners',
    children: openSpinnersRoutes,
  },
  {
    path: 'request-physical-collection',
    children: requestPhysicalCollectionRoutes,
  },
];
